// extracted by mini-css-extract-plugin
export default {"steps":"StepsContainer_steps__wBxAP","message":"StepsContainer_message__7r5Ox"};